import { createListenerMiddleware } from "@reduxjs/toolkit";
import { ActionTypes as ExtraProductsActionTypes } from "../ancillaries/store/extraProducts/actions.js";
import { ActionTypes as FlightDetailsActionTypes } from "./flightDetails/actions.js";
import { ActionTypes as OrderActionsTypes } from "./order/actions.js";
import { ActionTypes as SearchReasultsActionTypes } from "./searchResults/actions.js";
import { offerExtraProduct } from "../utils/checkoutOfferPersistedStore.js";
import { flightsLocalStore, flightsSessionStore } from "@flights/web-api-utils-universal";
import { ALTERNATIVE_FARES_REQUEST_DATA_TIMEOUT, ALTERNATIVE_FARES_FLIGHT_OFFER_OBJECT_KEY, CURRENT_ORDER_ID_KEY, SIRF_AVAILABLE_KEY, CURRENT_ORDER_TOKEN_KEY } from "../constants.js";
import { isSirfAvailable } from "./selectors/sirf.js";
export const listenerMiddleware = createListenerMiddleware();
const addExtraProductEffect = ({ payload: { productType } }, listenerApi) => {
    const rootState = listenerApi.getState();
    const offerToken = rootState.flightDetails.flight?.token || "";
    const selectedExtraProducts = rootState.extraProducts.selected;
    if (!offerToken) {
        throw new Error("No offerToken found while updating persisted store");
    }
    offerExtraProduct.add({
        offerToken,
        key: productType,
        value: selectedExtraProducts[productType]
    });
};
const removeExtraProductEffect = ({ payload: { productType } }, listenerApi) => {
    const rootState = listenerApi.getState();
    const offerToken = rootState.flightDetails.flight?.token || "";
    if (!offerToken) {
        throw new Error("No offerToken found while updating persisted store");
    }
    offerExtraProduct.remove({
        offerToken,
        key: productType
    });
};
listenerMiddleware.startListening({
    type: ExtraProductsActionTypes.addProduct,
    effect: (action, listenerApi) => addExtraProductEffect(action, listenerApi)
});
listenerMiddleware.startListening({
    type: ExtraProductsActionTypes.removeProduct,
    effect: (action, listenerApi) => removeExtraProductEffect(action, listenerApi)
});
listenerMiddleware.startListening({
    type: ExtraProductsActionTypes.setProducts,
    effect: (action, listenerApi) => addExtraProductEffect(action, listenerApi)
});
listenerMiddleware.startListening({
    type: ExtraProductsActionTypes.removeAllProducts,
    effect: (action, listenerApi) => removeExtraProductEffect(action, listenerApi)
});
listenerMiddleware.startListening({
    type: FlightDetailsActionTypes.fetchSuccess,
    effect: (action) => {
        const flight = action.payload.flight;
        flightsLocalStore.set(ALTERNATIVE_FARES_FLIGHT_OFFER_OBJECT_KEY, flight, {
            ttl: ALTERNATIVE_FARES_REQUEST_DATA_TIMEOUT
        });
    }
});
listenerMiddleware.startListening({
    type: OrderActionsTypes.fetchSuccess,
    effect: (action) => {
        const orderId = action.payload.order.orderId;
        const orderToken = action.payload.order.orderToken;
        flightsLocalStore.set(CURRENT_ORDER_ID_KEY, orderId, { ttl: ALTERNATIVE_FARES_REQUEST_DATA_TIMEOUT });
        flightsLocalStore.set(CURRENT_ORDER_TOKEN_KEY, orderToken, { ttl: ALTERNATIVE_FARES_REQUEST_DATA_TIMEOUT });
    }
});
listenerMiddleware.startListening({
    type: SearchReasultsActionTypes.fetchSuccess,
    effect: (action) => {
        const subsidizedFareSummary = action.payload.subsidizedFaresSummary || [];
        const sirfAvailable = isSirfAvailable(subsidizedFareSummary);
        flightsSessionStore.set(SIRF_AVAILABLE_KEY, sirfAvailable);
    }
});
